import React, { useEffect, useCallback } from 'react';
import Footer from 'Components/Footer/Footer';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from 'Components/Header/Header';
import axiosInstance from 'Utils/Interceptor';
import {
  setHomePageData,
  setPackageFilterData
} from '../../Redux/features/APIsDataSlice';
import LocationModal from 'Pages/Home/Components/LocationModal';
import Loader from 'Components/Loader/Loader';
import {
  useQuery,
  getCityCoordinates,
  getCityFromCoordinates,
  slugify
} from 'Utils/Functions';
import { Tooltip } from 'react-tooltip';
import { useParams, useNavigate } from 'react-router-dom';
import { setUserLocation } from '../../Redux/features/LocationSlice';
import UTMTracker from 'Utils/UTMTracker';

const BaseLayout = ({
  _class,
  removeFooter,
  children,
  showMenu,
  showFooter,
  showCopyRight,
  cartHeader,
  from
}) => {
  let { cityId } = useSelector((state) => state.location);
  const homeData = useSelector((e) => e?.states.homePageData);
  const packageFilterData = useSelector((e) => e?.states.homePageData);
  const { isLocation } = useSelector((state) => state.location);
  const { openLocationModal } = useSelector((state) => state.state);
  const locationData = useSelector((state) => state.location);

  const isHeaderShow = useQuery('remove');
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { city } = useParams();
  const location = useLocation();

  const fetchHomeData = async () => {
    try {
      if (!cityId && isHeaderShow) {
        cityId = 1052;
      }
      const response = await axiosInstance.get(
        `/api/user/dashboard?banner_type=desktop&city_id=${cityId}`
      );

      dispatch(setHomePageData(response.data?.data));
    } catch (error) {}
  };

  const setLocation = useCallback(
    async (citySlug) => {
      try {
        const { data } = await axiosInstance(
          '/api/user/citydetail/' + citySlug
        );
        if (data.status) {
          const { lat, lng } = await getCityCoordinates(
            data.data.city_name,
            data.data.state_name
          );
          dispatch(
            setUserLocation({
              cityId: data.data.city_id,
              cityName: data.data.city_name,
              isLocation: true,
              stateId: data.data.state_id,
              stateName: data.data.state_name,
              lat,
              lng
            })
          );
        }
      } catch (error) {
        console.error('Error setting location:', error);
      }
    },
    [dispatch]
  );

  const checkCity = useCallback(
    async (city) => {
      try {
        const { data } = await axiosInstance('/api/user/citydetail/' + city);

        if (data.status) {
          let { lat, lng } = await getCityCoordinates(
            data.data.city_name,
            data.data.state_name
          );
          dispatch(
            setUserLocation({
              cityId: data.data.city_id,
              cityName: data.data.city_name,
              isLocation: true,
              stateId: data.data.state_id,
              stateName: data.data.state_name,
              lat: lat,
              lng: lng
            })
          );
        } else {
          dispatch(
            setUserLocation({
              ...locationData,
              isLocation: false
            })
          );
          navigate('/404');
        }
      } catch (error) {
        navigate('/404');
      }
    },
    [dispatch, locationData, navigate]
  );

  useEffect(() => {
    // Only run on homepage and if location is not already determined
    if (!locationData.isLocation) {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const cityInfo = await getCityFromCoordinates(latitude, longitude);
        console.log(latitude, longitude, 'latitude and longitude');

        console.log(cityInfo, 'cityInfo');
        if (cityInfo && cityInfo.city) {
          const citySlug = slugify(cityInfo.city);
          setLocation(citySlug);
        }
      },
      (error) => {
        // Geolocation failed or was denied. We will use the default location.
        console.error('Geolocation error:', error);
      }
    );
    }
    console.log(locationData, 'locationData');
  }, []);

  useEffect(() => {
    !homeData && fetchHomeData();
    // !packageFilterData && fetchFilterData();
  }, [cityId]);

  useEffect(() => {
    if (city) {
      checkCity(city);
    }
  }, []);

  const { token } = useSelector((state) => state.login);

  let _className = 'base-layout main-wrapper';

  if (_class) {
    _className = `${_class} ${_className}`;
  }
  if (token) {
    _className = `logged-in ${_className}`;
  }
  if (location.pathname === '/') {
    _className = `frontpage ${_className}`;
  } else {
    _className = `innerpage ${_className}`;
  }

  return (
    <div className="outer-wrapper">
      {!isHeaderShow ? (
        <div className={_className}>
          <Header
            showMenu={showMenu}
            cartHeader={cartHeader}
            from={from}
          />
          {children}
          {!removeFooter && <Footer showCopyRight={showCopyRight} />}
          {openLocationModal && <LocationModal />}
        </div>
      ) : (
        children
      )}
      <Loader />
      <Tooltip id="my-tooltip" />
      <UTMTracker />
    </div>
  );
};

export default BaseLayout;
